let util;

try {
  util = require('util');
} catch(e) {
  util = false;
}

if (
  typeof console !== undefined
  && !console.json
) {
  console.json = (...args) => {
    for (const arg of args) {
      if (util) {
        let finalArg;
        try {
          finalArg = arg.get({plain: true});
        } catch(e) {
          try {
            finalArg = arg.toJSON();
          } catch(e) {
            if (!arg) finalArg = arg;
            else if (arg.dataValues) finalArg = arg.dataValues;
            else if (arg.attributes) finalArg = arg.attributes;
            else finalArg = arg;
          }
        }
        console.log(util.inspect(
          finalArg,
          {
            colors: true,
            depth: null,
            compact: false,
          },
        ));
      } else if (
        Array.isArray(arg)
        || arg instanceof Object
      ) {
        console.log(JSON.stringify(arg, null, 2));
      } else {
        console.log(arg);
      }
    }
    return true;
  }
}